module.exports = __webpack_public_path__ + "static/img/tutoriales sin texto utopie-7.5e18a631.jpg";